import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.corporate-settings.company-profile', {
        url: '/companyProfile',
        component: 'companyProfile',
        resolve: {settings},
    });
}

/** @ngInject */
function settings(companyId,CorporateSettingsService) {
    return CorporateSettingsService.get(companyId);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/company-profile.state.js